// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"1744":"css/app.6741","3412":"css/admin-app.6741"}[chunkId] + ".css";
};